import axios from 'axios'

export default {
  namespaced: true,
  state: {
    users: [],
    user: null,
    referrals: [],
    count: 0,
    refCount: 0,
    memo: []
  },
  mutations: {
    SET_USERS (state, users) {
      state.users = users
    },
    SET_USERCOUNT (state, count) {
      state.count = count
    },
    SET_USER (state, user) {
      state.user = user
    }
  },
  actions: {
    async get ({ commit }, { status, params }) {
      // commit('SET_USERS', [])
      try {
        let jsonHardSorts = {
          'bank_account_name': {
            process (data, sort) {
              if (sort) {
                return _.sortBy(data, e => {
                  let chosen = []
                  chosen.push(_.find(e.wallets, dd => dd.is_main))
                  if (!chosen[0]) { chosen = e.wallets }
                  return chosen[0].bank_account_name.toLowerCase()
                })
              } else {
                return _.sortBy(data, e => {
                  let chosen = []
                  chosen.push(_.find(e.wallets, dd => dd.is_main))
                  if (!chosen[0]) { chosen = e.wallets }
                  return chosen[0].bank_account_name.toLowerCase()
                }).reverse()
              }
            }
          },
          'bank_account_number': {
            process (data, sort) {
              if (sort) {
                return _.sortBy(data, e => {
                  let chosen = []
                  chosen.push(_.find(e.wallets, dd => dd.is_main))
                  if (!chosen[0]) { chosen = e.wallets }
                  return chosen[0].bank_number.toLowerCase()
                })
              } else {
                return _.sortBy(data, e => {
                  let chosen = []
                  chosen.push(_.find(e.wallets, dd => dd.is_main))
                  if (!chosen[0]) { chosen = e.wallets }
                  return chosen[0].bank_number.toLowerCase()
                }).reverse()
              }
            }
          },
          'bank_name': {
            process (data, sort) {
              if (sort) {
                return _.sortBy(data, e => {
                  let chosen = []
                  chosen.push(_.find(e.wallets, dd => dd.is_main))
                  if (!chosen[0]) { chosen = e.wallets }
                  return chosen[0].bank_name.toLowerCase()
                })
              } else {
                return _.sortBy(data, e => {
                  let chosen = []
                  chosen.push(_.find(e.wallets, dd => dd.is_main))
                  if (!chosen[0]) { chosen = e.wallets }
                  return chosen[0].bank_name.toLowerCase()
                }).reverse()
              }
            }
          },
          'deposit_account_name': {
            process (data, sort) {
              if (sort) { return _.sortBy(data, e => e.code.bank_account_name.toLowerCase()) } else { return _.sortBy(data, e => e.code.bank_account_name.toLowerCase()).reverse() }
            }
          },
          'deposit_account_number': {
            process (data, sort) {
              if (sort) { return _.sortBy(data, e => e.code.bank_number.toLowerCase()) } else { return _.sortBy(data, e => e.code.bank_number.toLowerCase()).reverse() }
            }
          },
          'code': {
            process (data, sort) {
              if (sort) { return _.sortBy(data, e => e.code.code.toLowerCase()) } else { return _.sortBy(data, e => e.code.code.toLowerCase()).reverse() }
            }
          },
          'agent': {
            process (data, sort) {
              if (sort) { return _.sortBy(data, e => e.code.agent_id.toLowerCase()) } else { return _.sortBy(data, e => e.code.agent_id.toLowerCase()).reverse() }
            }
          }
        }
        let defaultSorter = (data, sort, sortBy) => {
          if (sort == 'asc') { return _.sortBy(data, e => e[sortBy]) } else { return _.sortBy(data, e => e[sortBy]).reverse() }
        }

        let users = await axios.get(`/users/${status}`, { params })

        let dataPass = users.data
        if (jsonHardSorts[params.sort_by]) {
          dataPass = jsonHardSorts[params.sort_by].process(dataPass, (params.sort == 'asc'))
        } else {
          dataPass = defaultSorter(dataPass, params.sort, params.sort_by)
        }
        commit('SET_USERS', dataPass)
      } catch (err) {
      }
    },

    async getCount ({ commit }, { status, params }) {
      // commit('SET_USERCOUNT', 1)
      try {
        let count = await axios.get(`/users/${status}/count`, { params })
        commit('SET_USERCOUNT', count.data)
      } catch (err) {
      }
    },

    async find ({ commit }, { id }) {
      try {
        let user = await axios
          .get(`/users/${id}/user`)
        commit('SET_USER', user.data[0])
      } catch (err) {
      }
    },

    async create ({ commit }, data) {
      return axios.post('/users', data)
    },

    async update ({ commit }, params) {
      let user = await axios.patch(`/users/${params.id}`, params.data)
      commit('SET_USER', params.user)
      return user
    },

    async delete ({ commit }, params) {
      let user = await axios.delete(`/users/${params.uid}`, { test: 1 })
      commit('SET_USER', params.user)
      return user
    },

    async setAgent ({ commit }, { user_id, agent_id }) {
      await axios.patch(`/agents/user/update/${user_id}`, { agent_id })
    }
  }
}
